<template>
  <div :data-visible="visible" class="form-notice">
    <div class="container">

      <div class="content">
        <div class="words">
          <slot></slot>
        </div>

        <div class="controls bottom">
          <button @click.prevent="hide">{{ modalCloseButton }}</button>
        </div>
      </div>


    </div>
  </div>
</template>

<script>
export default {
  name: "FormNotice",
  props: [ "modalCloseButton" ],
  data: () => {
    return {
      visible: false,
    }
  },
  methods: {
    show () {
      this.visible = true
    },
    hide () {
      this.visible = false
    }
  }
}
</script>

<style lang="scss">
  .form-notice {
    display: none;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 999;
    background-color: $color-white;
    background-color: fade-out($color: $color-white, $amount: 0.2);

    &[data-visible="true"] {
      display: block;
    }

    .controls {
      position: absolute;
      bottom: 20px;
      right: 20px;

      button {
        padding: 0.5em 1em;
        border: none;
        border-radius: 15px;
        background-color: $color-blue;
        color: $color-white;
        cursor: pointer;

        &:hover, &:focus, &:active {
          color: $color-black;
          background-color: $color-grey-dark;
        }
      }
    }

    .container {
      position: relative;
      display: flex;
      flex-flow: row nowrap;
      justify-content: center;
      align-items: center;
      height: 100%;
    }

    .content {
      position: relative;
      width: 100%;
      min-height: 50vh;
      max-height: 80vh;
      background-color: $color-white;
      border-radius: 10px;
      border: solid 3px $color-grey;
      padding: 50px 20px 70px 20px;

      @media screen and (max-width: $break-mobile) {
        padding: 20px 20px 70px 20px;
      }

      .words {
        max-height: 80vh;
        overflow: auto;
        padding: 0 20px;
        font-size: 0.8em;

        @media screen and (max-width: $break-mobile) {
          padding: 0 10px 0 0;
        }
      }

      .words p {
        font-size: 0.9em;
      }
    }
  }
</style>
